module.exports = "data:image/gif;base64,R0lGODdhMgAyAOMAANLW3v////n5+vP09uLl6tfb4ujq7u7v8t3g5gAAAAAAAAAAAAAAAAAAAAAAAAAAACwAAAAAMgAyAAAEbRDISau9OOvNu/9gKI5kaZ5oqq5s675wLM90bd94ru987/81wYBAEBAuQqLxJZAMCgOkE8ocRqOAgwGbvL4KgEETWwiAAWBx+HUcPMkChKT9ZgsMxWO4OL/ngYCBgoOEhYaHiImKi4yNjo+QgBEAOw=="


//////////////////
// WEBPACK FOOTER
// ./~/admin-lte/dist/img/default-50x50.gif
// module id = 42
// module chunks = 0